export const heroSlides = [
  {
    title: '开云体育 · 精彩无限',
    subtitle: '全球顶级体育赛事，实时赔率，安全竞猜',
    cta: '立即注册',
    ctaLink: '#',
    secondaryCta: '了解更多',
    secondaryLink: '/about',
    features: ['安全可靠', '提现秒到', '24h客服'],
  },
];

export const liveMatches = [
  {
    id: 'match-1',
    league: '英超联赛',
    leagueIcon: 'ri-football-line',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeScore: 2,
    awayScore: 1,
    time: '78\'',
    status: 'live',
    odds: { home: 1.85, draw: 3.40, away: 4.20 },
    viewers: '128.6万',
  },
  {
    id: 'match-2',
    league: 'NBA',
    leagueIcon: 'ri-basketball-line',
    homeTeam: '湖人',
    awayTeam: '勇士',
    homeScore: 98,
    awayScore: 102,
    time: 'Q4 5:32',
    status: 'live',
    odds: { home: 2.10, away: 1.72 },
    viewers: '256.3万',
  },
  {
    id: 'match-3',
    league: '欧冠联赛',
    leagueIcon: 'ri-football-line',
    homeTeam: '皇马',
    awayTeam: '拜仁',
    homeScore: 0,
    awayScore: 0,
    time: '35\'',
    status: 'live',
    odds: { home: 2.25, draw: 3.30, away: 3.10 },
    viewers: '389.1万',
  },
  {
    id: 'match-4',
    league: 'LPL夏季赛',
    leagueIcon: 'ri-gamepad-line',
    homeTeam: 'JDG',
    awayTeam: 'BLG',
    homeScore: 1,
    awayScore: 1,
    time: 'BO3 G3',
    status: 'live',
    odds: { home: 1.95, away: 1.85 },
    viewers: '198.7万',
  },
];

export const hotMatches = [
  {
    id: 'hot-1',
    league: '西甲',
    homeTeam: '巴塞罗那',
    awayTeam: '马德里竞技',
    startTime: '今晚 03:00',
    odds: { home: 1.65, draw: 3.80, away: 5.00 },
    hotTag: '热门推荐',
  },
  {
    id: 'hot-2',
    league: '英超',
    homeTeam: '利物浦',
    awayTeam: '切尔西',
    startTime: '明晚 00:30',
    odds: { home: 2.00, draw: 3.40, away: 3.60 },
    hotTag: '焦点战',
  },
  {
    id: 'hot-3',
    league: 'NBA',
    homeTeam: '凯尔特人',
    awayTeam: '雄鹿',
    startTime: '明早 08:00',
    odds: { home: 1.55, away: 2.45 },
    hotTag: '东部强强对话',
  },
  {
    id: 'hot-4',
    league: '法网',
    homeTeam: '阿尔卡拉斯',
    awayTeam: '德约科维奇',
    startTime: '今晚 21:00',
    odds: { home: 2.30, away: 1.60 },
    hotTag: '决赛',
  },
  {
    id: 'hot-5',
    league: 'DOTA2 TI',
    homeTeam: 'Team Spirit',
    awayTeam: 'Gaimin Gladiators',
    startTime: '后天 18:00',
    odds: { home: 1.90, away: 1.90 },
    hotTag: '淘汰赛',
  },
  {
    id: 'hot-6',
    league: '中超',
    homeTeam: '上海海港',
    awayTeam: '山东泰山',
    startTime: '今晚 19:35',
    odds: { home: 1.75, draw: 3.50, away: 4.50 },
    hotTag: '',
  },
];

export const categories = [
  {
    id: 'football',
    name: '足球',
    icon: 'ri-football-line',
    description: '五大联赛、欧冠、世界杯等全球顶级足球赛事实时竞猜',
    matchCount: 1280,
    color: 'bg-primary-500',
  },
  {
    id: 'basketball',
    name: '篮球',
    icon: 'ri-basketball-line',
    description: 'NBA、CBA、欧洲篮球联赛等精彩赛事一网打尽',
    matchCount: 860,
    color: 'bg-accent-500',
  },
  {
    id: 'esports',
    name: '电竞',
    icon: 'ri-gamepad-line',
    description: 'LOL、DOTA2、CS2等热门电竞赛事实时数据与竞猜',
    matchCount: 540,
    color: 'bg-secondary-500',
  },
  {
    id: 'tennis',
    name: '网球',
    icon: 'ri-trophy-line',
    description: '大满贯、ATP、WTA巡回赛全程覆盖',
    matchCount: 320,
    color: 'bg-accent-700',
  },
];

export const advantages = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '多重加密技术保障用户资金与信息安全，持有合法运营牌照，安心畅玩。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '提现秒到',
    description: '多渠道快速提现，审核通过后资金秒到账，告别漫长等待。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '全天客服',
    description: '专业客服团队7x24小时在线支持，随时解答您的疑问，服务零距离。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端畅玩',
    description: '支持PC、手机、平板多终端无缝切换，随时随地享受体育竞猜乐趣。',
  },
];

export const newsArticles = [
  {
    id: 'article-1',
    title: '2026年世界杯预选赛亚洲区12强赛完整赛程公布',
    excerpt: '国际足联正式公布了2026年世界杯亚洲区预选赛12强赛的完整赛程安排，中国队将在9月迎战首轮对手。',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-07',
    imageSeq: 'news-football-worldcup',
    tags: ['世界杯', '预选赛', '亚洲区'],
  },
  {
    id: 'article-2',
    title: 'NBA夏季转会窗口：湖人完成重磅交易，詹姆斯搭档再升级',
    excerpt: 'NBA夏季转会市场再掀波澜，洛杉矶湖人队通过一笔三方交易获得了全明星级别球员，新赛季阵容令人期待。',
    category: '篮球',
    categorySlug: 'basketball',
    date: '2026-08-06',
    imageSeq: 'news-nba-trade',
    tags: ['NBA', '转会', '湖人'],
  },
  {
    id: 'article-3',
    title: '英雄联盟S16全球总决赛赛制改革：新增瑞士轮赛制',
    excerpt: '拳头游戏宣布S16全球总决赛将引入瑞士轮赛制，这一重大改革将彻底改变赛事格局，让比赛更加公平刺激。',
    category: '电竞',
    categorySlug: 'esports',
    date: '2026-08-05',
    imageSeq: 'news-lol-s16',
    tags: ['英雄联盟', 'S16', '赛制改革'],
  },
  {
    id: 'article-4',
    title: '英超新赛季前瞻：六强格局巨变，谁能登顶？',
    excerpt: '2026-2027赛季英超联赛即将开幕，在夏季转会窗的大手笔引援后，传统六强的实力对比发生了显著变化。',
    category: '足球',
    categorySlug: 'football',
    date: '2026-08-04',
    imageSeq: 'news-epl-preview',
    tags: ['英超', '赛季前瞻', '六强'],
  },
  {
    id: 'article-5',
    title: '开云体育荣获"2026年度最佳在线体育平台"大奖',
    excerpt: '在刚刚结束的2026年国际博彩博览会上，kaiyun.com凭借卓越的用户体验和安全保障体系，荣获年度最佳平台奖。',
    category: '平台动态',
    categorySlug: 'news',
    date: '2026-08-03',
    imageSeq: 'news-award-2026',
    tags: ['开云体育', '获奖', '平台动态'],
  },
  {
    id: 'article-6',
    title: '网球大满贯赛事竞猜攻略：从入门到精通的五大技巧',
    excerpt: '想要在网球大满贯赛事中提高竞猜胜率？本文汇总了五大实用技巧，帮助新手玩家快速上手，理性参与。',
    category: '攻略',
    categorySlug: 'news',
    date: '2026-08-02',
    imageSeq: 'news-tennis-guide',
    tags: ['网球', '竞猜攻略', '大满贯'],
  },
];

export const faqItems = [
  {
    question: '如何在 kaiyun.com 注册账号？',
    answer: '点击网站右上角的"立即注册"按钮，填写手机号或邮箱，设置密码，完成短信/邮箱验证即可成功注册。整个过程只需1-2分钟。',
  },
  {
    question: 'kaiyun.com 支持哪些充值方式？',
    answer: '我们支持多种充值方式，包括银行卡转账、微信支付、支付宝、USDT等加密货币，以及多种电子钱包。充值实时到账，无手续费。',
  },
  {
    question: '提现需要多长时间到账？',
    answer: 'kaiyun.com 以提现速度快著称，审核通过后小额提现秒到账，大额提现通常在30分钟内到账。我们承诺全网最快的提现速度。',
  },
  {
    question: 'kaiyun.com 平台是否安全可靠？',
    answer: 'kaiyun.com 持有国际合法运营牌照，采用银行级SSL加密技术保护用户数据，所有资金由第三方托管，确保平台安全可靠运营。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过在线客服（7x24小时）、官方邮箱 support@kaiyun.com 或官方社交媒体账号联系我们。我们的客服团队随时为您服务。',
  },
];

export const stats = [
  { value: '5000万+', label: '注册用户' },
  { value: '128+', label: '覆盖国家' },
  { value: '99.9%', label: '资金安全率' },
  { value: '10秒', label: '平均提现速度' },
];